import {
  SET_MESSAGE,
  REMOVE_MESSAGE,
  SET_NAV_MENU_SUB_TEXT,
  REMOVE_NAV_MENU_SUB_TEXT,
} from './types';

// The title of the header; with a link it opens e.g. the list of the offers. The phase,
// e.g. Mahdollisuus or Tarjous, is shown before it, the version of an offer that has
// several after it.
export const setNavMenuText = (
  text: string,
  link?: string,
  phase?: string,
  revision?: null | number
): {
  link?: string;
  phase?: string;
  revision?: null | number;
  type: string;
  text: string;
} => ({
  link,
  phase,
  revision,
  type: SET_MESSAGE,
  text,
});

export const removeNavMenuText = (): { type: string; text: string } => ({
  type: REMOVE_MESSAGE,
  text: '',
});

// A second part of the header, e.g. the position and alternative being calculated
export const setNavMenuSubText = (
  text: string
): {
  type: string;
  text: string;
} => ({
  type: SET_NAV_MENU_SUB_TEXT,
  text,
});

export const removeNavMenuSubText = (): { type: string; text: string } => ({
  type: REMOVE_NAV_MENU_SUB_TEXT,
  text: '',
});
